export const cleanTaskActivityData = (activity: TaskActivityResponse[]) => {
  // Remove erroneous update events (those which don't indicate a change in values)
  const fixed = activity.map((event) => {
    if (event.action === "updated") {
      const content = {};

      Object.entries(event.content ?? {}).forEach(([key, val]) => {
        if (val.previous !== val.value) {
          content[key] = val;
        }
      });

      return {
        ...event,
        content: Object.keys(content).length > 0 ? content : null,
      };
    }

    return event;
  });

  // Remove updates with no changes
  const filtered = fixed.filter((event) => {
    if (event.action !== "updated") {
      return true;
    }

    return event.content !== null;
  });

  // Sort from newest to oldest
  const sorted = filtered.sort(
    (a, b) => +new Date(b.stamp) - +new Date(a.stamp),
  );

  return sorted;
};

export const cleanUserActivityData = (activity: UserActivityResponse[]) => {
  // Remove erroneous update events (those which don't indicate a change in values)
  const fixed = activity.map((event) => {
    if (event.action === "updated") {
      const content = {};

      Object.entries(event.content ?? {}).forEach(([key, val]) => {
        if (val.previous !== val.value) {
          content[key] = val;
        }
      });

      return {
        ...event,
        content: Object.keys(content).length > 0 ? content : null,
      };
    }

    return event;
  });

  // Remove updates with no changes
  const filtered = fixed.filter((event) => {
    if (event.action !== "updated") {
      return true;
    }

    return event.content !== null;
  });

  // Sort from newest to oldest
  const sorted = filtered.sort(
    (a, b) => +new Date(b.stamp) - +new Date(a.stamp),
  );

  return sorted;
};
